var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStaking = function SvgStaking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#staking_svg__a)",
    fillRule: "evenodd",
    d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A659B",
    d: "M41.243 45.826c5.694 0 10.31-4.617 10.31-10.311 0-5.695-4.616-10.31-10.31-10.31s-10.31 4.615-10.31 10.31c0 5.694 4.615 10.31 10.31 10.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A19EC5",
    fillRule: "evenodd",
    d: "M29.787 45.826c5.694 0 10.31-4.617 10.31-10.311 0-5.695-4.616-10.31-10.31-10.31s-10.31 4.615-10.31 10.31c0 5.694 4.615 10.31 10.31 10.31",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "staking_svg__a",
    x1: 35,
    x2: 35,
    y1: 0,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E8F3"
  })))));
};
export { SvgStaking as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNSA3MEM1NC4zMyA3MCA3MCA1NC4zMyA3MCAzNUM3MCAxNS42NyA1NC4zMyAwIDM1IDBDMTUuNjcgMCAwIDE1LjY3IDAgMzVDMCA1NC4zMyAxNS42NyA3MCAzNSA3MFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZD0iTTQxLjI0MjkgNDUuODI1N0M0Ni45Mzc0IDQ1LjgyNTcgNTEuNTUzNyA0MS4yMDk0IDUxLjU1MzcgMzUuNTE0OUM1MS41NTM3IDI5LjgyMDQgNDYuOTM3NCAyNS4yMDQxIDQxLjI0MjkgMjUuMjA0MUMzNS41NDg0IDI1LjIwNDEgMzAuOTMyMSAyOS44MjA0IDMwLjkzMjEgMzUuNTE0OUMzMC45MzIxIDQxLjIwOTQgMzUuNTQ4NCA0NS44MjU3IDQxLjI0MjkgNDUuODI1N1oiIGZpbGw9IiM2QTY1OUIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS43ODY4IDQ1LjgyNTdDMzUuNDgxMyA0NS44MjU3IDQwLjA5NzYgNDEuMjA5NCA0MC4wOTc2IDM1LjUxNDlDNDAuMDk3NiAyOS44MjA0IDM1LjQ4MTMgMjUuMjA0MSAyOS43ODY4IDI1LjIwNDFDMjQuMDkyNCAyNS4yMDQxIDE5LjQ3NjEgMjkuODIwNCAxOS40NzYxIDM1LjUxNDlDMTkuNDc2MSA0MS4yMDk0IDI0LjA5MjQgNDUuODI1NyAyOS43ODY4IDQ1LjgyNTdaIiBmaWxsPSIjQTE5RUM1Ii8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIzNSIgeTE9IjAiIHgyPSIzNSIgeTI9IjcwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0U3RThGMyIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";